import { render, staticRenderFns } from "./ProductContainersGroup.vue?vue&type=template&id=3f7f696a&scoped=true"
import script from "./ProductContainersGroup.vue?vue&type=script&lang=js"
export * from "./ProductContainersGroup.vue?vue&type=script&lang=js"
import style0 from "./ProductContainersGroup.vue?vue&type=style&index=0&id=3f7f696a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7f696a",
  null
  
)

export default component.exports